<template>
  <li
    v-if="department"
    class="members__content department-menu">
    <div
      class="d-flex align-items-center p-3 justify-content-between">
      <div class="d-flex align-items-center">
        <p>
          <span class="material-icons members__icon mr-3">people</span>
        </p>
        <div class="members__content">
          <p class="members__name">
            {{ department.name }}
          </p>
        </div>
      </div>
      <div
        class="d-flex justify-content-between"
        @click.stop>
        <big-check-box
          :id="department.id"
          :checked="isCheckedDepartment"
          :disabled="false"
          @click.native="onCheckedDepartment" />
        <slot name="pin-icon" />
      </div>
    </div>
    <transition name="list-menu">
      <div
        v-if="showMembers"
        @click.stop>
        <ul
          class="members__list list-unstyled">
          <slot />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
import BigCheckBox from '@/components/parts/BigCheckBox'

export default {
  components: {
    BigCheckBox
  },
  props: {
    department: {
      type: Object,
      default: null
    },
    showMembers: {
      type: Boolean,
      default: false
    },
    isCheckedDepartment: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onCheckedDepartment() {
      this.$emit('department-checked', this.department.id)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/members.scss";

.department-menu :hover{
   cursor: pointer;
}

.list-menu-enter-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.list-menu-leave-active {
  transition: all 0.1s;
}
.list-menu-enter, .list-menu-leave-to {
  opacity: 0;
  transform: translateY(-15px);
}
</style>